import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-700b8d46"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjYzVkYmZmIiBkPSJNMCAwaDUxMnY1MTJIMHoiLz48cGF0aCBkPSJNMjU2IDMwNGM2MS42IDAgMTEyLTUwLjQgMTEyLTExMlMzMTcuNiA4MCAyNTYgODBzLTExMiA1MC40LTExMiAxMTIgNTAuNCAxMTIgMTEyIDExMnptMCA0MGMtNzQuMiAwLTIyNCAzNy44LTIyNCAxMTJ2NTZoNDQ4di01NmMwLTc0LjItMTQ5LjgtMTEyLTIyNC0xMTJ6IiBmaWxsPSIjODJhZWZmIi8+PC9zdmc+" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_item = _resolveComponent("ion-item")!

  return (_openBlock(), _createBlock(_component_ion_item, {
    lines: "full",
    "router-link": {
      name: 'PostDetailPage',
      params: { id: $props.post.id },
      state: { ...$props.extraRouterParams },
    },
    button: "",
    detail: ""
  }, {
    default: _withCtx(() => [
      (!$setup.isPostAuthorBanned($props.post) && $props.post.image)
        ? (_openBlock(), _createBlock(_component_ion_thumbnail, {
            key: 0,
            slot: "start"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: $props.post.image
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_ion_label, null, {
        default: _withCtx(() => [
          (!$setup.isPostAuthorBanned($props.post))
            ? (_openBlock(), _createElementBlock("h3", _hoisted_2, [
                _createTextVNode(_toDisplayString($props.post.title) + " ", 1),
                ($props.post.likeCount >= $props.post.dislikeCount)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_3, [
                      _createVNode(_component_ion_icon, { icon: $setup.thumbsUpOutline }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString($props.post.likeCount - $props.post.dislikeCount), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("small", _hoisted_4, [
                      _createVNode(_component_ion_icon, { icon: $setup.thumbsDownOutline }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString($props.post.dislikeCount - $props.post.likeCount), 1)
                    ])),
                _createTextVNode(" " + _toDisplayString($props.post.rating), 1)
              ]))
            : _createCommentVNode("", true),
          (!$setup.isPostAuthorBanned($props.post))
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString($props.post.content), 1))
            : _createCommentVNode("", true),
          ($setup.isPostAuthorBanned($props.post))
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString($setup.t('PostPage.blockedContent')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, [
            _createElementVNode("small", null, _toDisplayString($setup.formatDate($props.post.createdAt)), 1)
          ]),
          _createVNode(_component_ion_chip, { class: "user-chip" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_avatar, null, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_ion_label, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($props.post.username || 'Unknown'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["router-link"]))
}